import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-046a0032"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "box" }
const _hoisted_2 = { class: "my-approval" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "approval" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "name" }, "我的审批"),
  /*#__PURE__*/_createElementVNode("div", { class: "iconfont" }, "")
], -1))
const _hoisted_4 = { class: "agent" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "iconfont" }, "", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "my" }, "我待办的", -1))
const _hoisted_7 = { class: "number" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "iconfont" }, "", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "my" }, "我发起的", -1))
const _hoisted_10 = { class: "number" }
const _hoisted_11 = { class: "commission" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "iconfont" }, "", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "已超时的代办", -1))
const _hoisted_14 = { class: "number" }
const _hoisted_15 = { class: "my-project my-approval" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "name" }, "我的项目", -1))
const _hoisted_17 = { class: "agent" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "iconfont" }, "", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "my" }, "我负责的", -1))
const _hoisted_20 = { class: "number" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "iconfont" }, "", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "my" }, "我参与的", -1))
const _hoisted_23 = { class: "number" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "commission" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "iconfont" }, ""),
  /*#__PURE__*/_createElementVNode("div", null, "最近跟进的项目")
], -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dotted" }, null, -1))
const _hoisted_26 = { class: "name" }
const _hoisted_27 = { class: "name-left" }
const _hoisted_28 = { class: "name-right" }

import { onMounted, ref } from 'vue'
import { useRouter } from 'vue-router'
import { getProjectStatistics, getApprove, getStaffInfo } from '@/apis/home'
import { getProjectList } from '@/apis/projectList'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter()

const ProjectList = ref([])
const approveData = ref({
  launch: 0, // 我发起的项目
  need: 0, // 我代办的项目
  overtime: 0 // 超时项目
})
const statisData = ref({
  my_launch_nums: 0, // 我发起的项目数
  my_leader_nums: 0, //我负责的项目数
  my_have_nums: 0, //我参与的项目数
  total_nums: 0, // 项目总数
  my_total_nums: 0 //我的项目总数
})

const get_Statistics = async () => {
  const res = await getProjectList({ limit: 3 })
  if (res.code === 200) ProjectList.value = res.data
  const res1 = await getApprove()
  if (res1.code === 200) approveData.value = res1.data
  let need: any = approveData.value.need
  const res2 = await getProjectStatistics()
  if (res2.code === 200) statisData.value = res2.data
}

// 去审批页面
const to_approva = num => {
  if (num === 3) router.push('/approval?tabsActive=3')
  if (num === 1) router.push('/approval?tabsActive=1')
}

// 去项目页面
const to_project = num => {
  if (num === 2) router.push('/project?tabsActive=2')
  if (num === 1) router.push('/project?tabsActive=1')
}

const to_declare = () => {
  router.push('/project/declare')
}

const get_Staff_Info = async () => {
  const res = await getStaffInfo()
  if (res.code === 200) {
    let data = {
      id: res.data.id,
      cf_id: res.data.cf_id,
      is_oadmin: res.data.is_oadmin,
      job_grade: res.data.job_grade,
      jobid: res.data.jobid,
      name: res.data.name,
      parent_id: res.data.parent_id,
      phone_number: res.data.phone_number,
      avatar: res.data.avatar,
      state: res.data.state,
      superior_id: res.data.superior_id,
      type: res.data.type,
      working_state: res.data.avaworking_statetar,
      company_froms: res.data.company_froms,
      jobs: res.data.jobs,
      staff_extend: res.data.staff_extend,
      sex: res.data.sex
    }
    localStorage.setItem('STAFFINFO', JSON.stringify(data))
  }
}

onMounted(() => {
  get_Statistics()
  get_Staff_Info()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", {
          class: "agent-sty agent-left",
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (to_approva(1)), ["stop"]))
        }, [
          _hoisted_5,
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, _toDisplayString(approveData.value.need), 1)
        ]),
        _createElementVNode("div", {
          class: "agent-sty agent-right",
          onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (to_approva(3)), ["stop"]))
        }, [
          _hoisted_8,
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, _toDisplayString(approveData.value.launch), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _hoisted_12,
        _hoisted_13,
        _createElementVNode("div", _hoisted_14, _toDisplayString(approveData.value.overtime), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("div", { class: "project" }, [
        _hoisted_16,
        _createElementVNode("div", {
          class: "declare",
          onClick: to_declare
        }, "项目申报 +")
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("div", {
          class: "agent-sty agent-left",
          onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (to_project(1)), ["stop"]))
        }, [
          _hoisted_18,
          _hoisted_19,
          _createElementVNode("div", _hoisted_20, _toDisplayString(statisData.value.my_leader_nums), 1)
        ]),
        _createElementVNode("div", {
          class: "agent-sty agent-right",
          onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (to_project(2)), ["stop"]))
        }, [
          _hoisted_21,
          _hoisted_22,
          _createElementVNode("div", _hoisted_23, _toDisplayString(statisData.value.my_have_nums), 1)
        ])
      ]),
      _hoisted_24,
      _hoisted_25,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ProjectList.value, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "project-name",
          key: index
        }, [
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("div", _hoisted_27, _toDisplayString(item.name), 1),
            _createElementVNode("div", _hoisted_28, _toDisplayString(item.stage_name), 1)
          ])
        ]))
      }), 128))
    ])
  ]))
}
}

})